import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './IconInCircle.scss'
import DynamicFaIcon from '../DynamicFaIcon/DynamicFaIcon'
import { faBoxTaped } from '@fortawesome/pro-light-svg-icons'
import { Tooltip } from 'react-tooltip'

interface IconInCircleProps {
    icon?: IconProp
    size?: 'small'
    iconName?: string
    borderColor?: string
    bgColor?: string
    textColor?: string
    badge?: 'top' | 'bottom'
    tooltip?: string
}

const IconInCircle = ({ icon, size, iconName, borderColor, bgColor, textColor, badge, tooltip }: IconInCircleProps) => {
    const tooltipId = `tooltip-${Math.random().toString(6).slice(2, 9)}`

    return (
        <>
            <div
                id='IconInCircle'
                data-tooltip-id={tooltipId}
                className={`border border-opacity-50 flex-shrink-0 ${size === 'small' ? 'w-6 h-6' : 'w-10 h-10'} ${
                    tooltip ? 'cursor-pointer' : ''
                } ${borderColor ? borderColor : ''} ${
                    badge === 'top' ? 'badgeTop' : badge === 'bottom' ? 'badgeBottom' : ''
                } rounded-full flex items-center justify-center ${textColor ? textColor : ''} ${
                    bgColor ? bgColor : ''
                } `}
            >
                {iconName ? (
                    <DynamicFaIcon
                        className={`${size === 'small' ? 'text-xs' : 'text-xl'}`}
                        iconName={iconName}
                        color={textColor}
                    />
                ) : (
                    <FontAwesomeIcon
                        className={`${size === 'small' ? 'text-xs' : 'text-xl'}`}
                        icon={icon ? icon : faBoxTaped}
                        color={textColor}
                    />
                )}
            </div>
            {tooltip && (
                <Tooltip
                    id={tooltipId}
                    content={tooltip}
                    place='top'
                    style={{ backgroundColor: 'white', color: 'black' }}
                />
            )}
        </>
    )
}

export default IconInCircle
